<div class="flex flex-row justify-between items-center">
  <div>
    <mx-detail-field titleText="Balance:" [value]="accountSelectors.currentAccountBalance | select | format: 'CURRENCY'"
                     titleCSSClasses="text-headline-medium" valueCSSClasses="text-headline-large"/>
    @if (balanceExpanded) {
      <div class="flex flex-row mt-3" [mxDetailFieldDefaults]="{ titleCSSClasses: 'text-title-large', valueCSSClasses: 'text-headline-small' }">
        <mx-detail-field class="w-[11.25rem]" titleText="Wallet:" [value]="accountSelectors.walletBalance | select | format: 'CURRENCY'"/>
        <mx-detail-field class="w-[11.25rem]" titleText="Deposit:" [value]="accountSelectors.depositBalance | select | format: 'CURRENCY'"/>
      </div>
    }

    <px-see-more-less-button [expanded]="balanceExpanded" (click)="toggleExpandedBalance()"/>
  </div>

  <!-- Temporarily disable the button until our API can handle payments on a dependent's behalf. -->
  @if (!forDependent && (squareAppSelectors.hasSquareConfig | select)) {
    <mx-filled-button label="Make a Payment" [enabled]="hasMinimumOnlinePaymentBalance | select:false"
                      [tooltip]="makeAPaymentTooltip | select:''" (click)="onClickMakeAPayment()"/>
  }
</div>
